export default __webpack_public_path__ + "static/media/NoImage.e1ce751e.jpg";